import { lodestarColors, ursaColors } from "@smartsheet/design-tokens";
import { themed } from "@smartsheet/sds-theme-internal";
import { mapButtonAppearance } from "./mapButtonAppearance";
export var buttonTextColorTheme = themed({
  primary: {
    enabled: {
      "lodestar-light": lodestarColors.neutralLight40,
      oldestar: "#ffffff",
      "ursa-light": lodestarColors.neutralLight40
    },
    active: {
      "lodestar-light": lodestarColors.neutralLight40,
      oldestar: "#ffffff",
      "ursa-light": lodestarColors.neutralLight40
    },
    disabled: {
      "lodestar-light": lodestarColors.neutralLight40,
      oldestar: "#ffffff",
      "ursa-light": lodestarColors.neutralLight40
    }
  },
  secondary: {
    enabled: {
      "lodestar-light": lodestarColors.neutralDark30,
      oldestar: "#ffffff",
      "ursa-light": lodestarColors.neutralDark30
    },
    active: {
      "lodestar-light": lodestarColors.neutralDark30,
      oldestar: "#ffffff",
      "ursa-light": lodestarColors.neutralDark30
    },
    disabled: {
      "lodestar-light": lodestarColors.neutralAccessible,
      oldestar: "#ffffff",
      "ursa-light": lodestarColors.neutralAccessible
    }
  },
  destructive: {
    enabled: {
      "lodestar-light": lodestarColors.neutralLight40,
      oldestar: "#ffffff",
      "ursa-light": lodestarColors.neutralLight40
    },
    active: {
      "lodestar-light": lodestarColors.neutralLight40,
      oldestar: "#ffffff",
      "ursa-light": lodestarColors.neutralLight40
    },
    disabled: {
      "lodestar-light": lodestarColors.neutralLight40,
      oldestar: "#ffffff",
      "ursa-light": lodestarColors.neutralLight40
    }
  },
  "secondary-destructive": {
    enabled: lodestarColors.buttonDestructive,
    active: lodestarColors.buttonDestructive,
    disabled: lodestarColors.dangerLight20
  },
  share: {
    enabled: {
      "lodestar-light": lodestarColors.neutralLight40,
      oldestar: "#ffffff",
      "ursa-light": lodestarColors.neutralLight40
    },
    active: {
      "lodestar-light": lodestarColors.neutralLight40,
      oldestar: "#ffffff",
      "ursa-light": lodestarColors.neutralLight40
    },
    disabled: {
      "lodestar-light": lodestarColors.neutralLight40,
      oldestar: "#ffffff",
      "ursa-light": lodestarColors.neutralLight40
    }
  },
  borderless: {
    enabled: lodestarColors.ctaLink,
    active: lodestarColors.focusDark,
    disabled: lodestarColors.neutralDark10
  },
  link: {
    enabled: {
      "lodestar-light": lodestarColors.ctaLink,
      "ursa-light": ursaColors.linkDefault
    },
    active: {
      "lodestar-light": lodestarColors.focusDark,
      "ursa-light": ursaColors.linkDark
    },
    disabled: lodestarColors.neutralDark10
  },
  "primary-filled": {
    enabled: ursaColors.blue25,
    active: ursaColors.blue25,
    disabled: ursaColors.blue25
  },
  "primary-empty": {
    enabled: ursaColors.blue600,
    active: ursaColors.blue600,
    disabled: ursaColors.blue300
  },
  "secondary-filled": {
    enabled: ursaColors.neutral800,
    active: ursaColors.neutral800,
    disabled: ursaColors.neutral400
  },
  "secondary-outlined": {
    enabled: ursaColors.neutral800,
    active: ursaColors.neutral800,
    disabled: ursaColors.neutral400
  },
  "secondary-empty": {
    enabled: ursaColors.neutral800,
    active: ursaColors.neutral800,
    disabled: ursaColors.neutral400
  },
  "canvas-filled": {
    enabled: ursaColors.slate700,
    active: ursaColors.slate700,
    disabled: ursaColors.slate400
  },
  "canvas-empty": {
    enabled: ursaColors.slate700,
    active: ursaColors.slate700,
    disabled: ursaColors.slate400
  },
  "destructive-filled": {
    enabled: ursaColors.neutral00,
    active: ursaColors.neutral00,
    disabled: ursaColors.neutral00
  },
  "destructive-empty": {
    enabled: ursaColors.red600,
    active: ursaColors.red600,
    disabled: ursaColors.red400
  }
});

// For mapping state to the fontSettings color object above
var mapStateToFontSettingsString = function mapStateToFontSettingsString(_ref) {
  var _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive;
  // Disabled should always win
  if (isDisabled) {
    return "disabled";
  }
  // Active should win over enabled
  if (isActive) {
    return "active";
  }
  return "enabled";
};
export var getButtonTextColor = function getButtonTextColor(_ref2) {
  var appearance = _ref2.appearance,
    state = _ref2.state,
    themeMode = _ref2.themeMode;
  var resolvedState = mapStateToFontSettingsString(state);
  return buttonTextColorTheme[mapButtonAppearance(appearance, themeMode)][resolvedState](themeMode);
};

// For mapping state to the color object above
var mapStateToTextVar = function mapStateToTextVar(_ref3) {
  var state = _ref3.state;
  // Disabled should always win
  if (state.isDisabled) {
    return "--smar--sds--button--color--text--disabled";
  }
  // Active should win over hover
  if (state.isActive) {
    return "--smar--sds--button--color--text--active";
  }
  return "--smar--sds--button--color--text--rest";
};
export var getButtonTextColorVar = function getButtonTextColorVar(props) {
  return "".concat(mapStateToTextVar(props));
};
//# sourceMappingURL=getButtonTextColor.js.map